module.exports = __webpack_public_path__ + "static/media/main-tradegala.3eca2805.png";